import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "../CreateEditUser/CreateEditUser.scss";
import { Link, useNavigate } from "react-router-dom";
import { callAPI } from "../../../../axios";
import dayjs from "dayjs";
import BasicModal from "../../../core/BaseComponents/Modal";

const MyAccount = () => {
    const [editForm, setEditForm] = useState(false);
    const [myAccountUpdatedSuccessMsg, setMyAccountUpdatedSuccessMsg] = useState('');
    const navigate = useNavigate();

    let userId = JSON.parse(localStorage.getItem("userDetails"))?.sid;

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch
    } = useForm({
        mode: 'onChange'
    });

    const onSubmit = () => {
        const accessTillDate = watch("accessTillDate") ? new Date(watch("accessTillDate")).toISOString().split("T")[0] : ""
        const payload = {
            userName: watch("userName"),
            firstName: watch("firstName"),
            lastName: watch("lastName"),
            phoneNo: watch("phoneNo"),
            accessTillDate: accessTillDate,
            roleSids: [watch('roles')[0]?.id],
            chainId: watch("chainId"),
            enabled: watch("enabled"),
            key: null
        };

        let apiPath = `user?sid=${userId}`;
        callAPI(apiPath, "PUT", payload)
            .then(function (response) {
                setMyAccountUpdatedSuccessMsg(response?.message)
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
            });
    };

    const handleReset = () => {
        reset();
    };

    const handleCancelButton = (e) => {
        e.preventDefault()
        navigate(-1);
    };

    useEffect(() => {
        let apiPath = `user?sid=${userId}`
        callAPI(apiPath, "GET")
            .then(function (response) {
                reset(response)
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
            })
    }, [])

    const UserRole = watch('roles') ? watch('roles')[0]?.role : "N.A";


    function formatDate(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    return (
        <>
            <div className="breadcrumb">
                <ul>
                    <li>
                        <Link to='/hms/ConfigurationNewHotel'>Dashboard </Link> <span className="arrow-color"> &gt; </span>
                    </li>
                    <li>My Account</li>
                </ul>
            </div>
            <div className="sub-header"><h1>My Account</h1></div>
            <form onSubmit={handleSubmit(onSubmit)} className="create-edit-user">
                <div className="row">
                    <div className="col-4">
                        <label htmlFor="email"><b>Email</b></label>
                        <p>{watch('userName')}</p>
                    </div>

                    <div className="col-4">
                        <label htmlFor="firstName"><b>First Name</b></label>
                        {
                            editForm ? <>
                                <input
                                    id="firstName"
                                    className="form-control"
                                    maxLength={30}
                                    type="text"
                                    {...register("firstName", {
                                        required: "Please Enter Your First Name",
                                        pattern: {
                                            value: /^[a-zA-Z. ]+$/,
                                            message: "Only Alphabets, dot & blank space allowed",
                                        },
                                    })}
                                />
                                {errors.firstName && (
                                    <p className="required">{errors.firstName.message}</p>
                                )}
                            </> : <p>{watch('firstName')}</p>
                        }

                    </div>

                    <div className="col-4">
                        <label htmlFor="lastName"><b>Last Name</b></label>
                        {
                            editForm ? <>
                                <input
                                    id="lastName"
                                    className="form-control"
                                    maxLength={30}
                                    type="text"
                                    {...register("lastName", {
                                        required: "Please Enter Your Last Name",
                                        pattern: {
                                            value: /^[a-zA-Z. ]+$/,
                                            message: "Only Alphabets, dot & blank space allowed",
                                        },
                                    })}
                                />
                                {errors.lastName && (
                                    <p className="required">{errors.lastName.message}</p>
                                )}
                            </> : <p>{watch('lastName')}</p>
                        }
                    </div>

                    <div className="col-4">
                        <label htmlFor="phoneNo"><b>Phone</b></label>
                        {
                            editForm ? <>
                                <input
                                    id="phoneNo"
                                    className="form-control"
                                    maxLength={12}
                                    minLength={10}
                                    {...register("phoneNo", {
                                        required: "Please Enter Phone Number",
                                        pattern: {
                                            value: /^[0-9]+$/,
                                            message: "Invalid phone number",
                                        },
                                        minLength: {
                                            value: 10,
                                            message: "Phone number must be at least 10 digits"
                                        }
                                    })}
                                />
                                {errors.phoneNo && (
                                    <p className="required">{errors.phoneNo.message}</p>
                                )}
                            </> : <p>{watch('phoneNo')}</p>}
                    </div>

                    <div className="col-4">
                        <label htmlFor="role"><b>User Role</b></label>
                        <p>{UserRole}</p>
                    </div>
                    {UserRole !== "Super Admin" && <div className="col-4">
                        <label htmlFor="role"><b>Linked Hotels</b></label>
                        <p>{watch('hotelName')?.split(",").map((item, index) => (index ? ", " : "") + item).join("")}</p>
                    </div>}

                    <div className="col-4">
                        <label htmlFor="date"><b>Access Till Date</b></label>
                        <p>{watch('accessTillDate') === null ? 'N.A' : formatDate(watch('accessTillDate'))}</p>
                    </div>
                    <div className="col-4">
                        <label htmlFor="date"><b>User Enabled</b></label>
                        <p>{watch('enabled') ? "Yes" : "No"}</p>
                    </div>
                    <div className="button-group">


                        {editForm ?
                            <>
                                <button
                                    type="button"
                                    className="cancel-btn_new"
                                    onClick={() => setEditForm(false)}
                                >
                                    Cancel
                                </button>
                                <button type="button" className="reset-btn" onClick={handleReset}>
                                    Reset
                                </button>
                                <button type="submit" className="create-btn">
                                    Update
                                </button>
                            </> :
                            <><button
                                type="button"
                                className="cancel-btn_new"
                                onClick={handleCancelButton}
                            >
                                Cancel
                            </button>
                                <button type="button" className="create-btn" onClick={(e) => { e.preventDefault(); setEditForm(true); }}>
                                    Edit
                                </button>
                            </>
                        }

                    </div>
                </div>
            </form>

            <BasicModal
                popupOpen={myAccountUpdatedSuccessMsg !== ""}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">{myAccountUpdatedSuccessMsg}</p>}
                // customcss={true}
                footer={
                    {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => { setMyAccountUpdatedSuccessMsg('');  setEditForm(false); },
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
        </>

    );
};

export default MyAccount;
